module.exports = __webpack_public_path__ + "static/media/story-preview-frame.564f46a6.png";